<table
  [id]="name"
  [dtOptions]="dtOptions"
  [dtTrigger]="dtTrigger"
  datatable
  class="table table-striped table-hover dataTable row-border hover"
  style="overflow-x:hidden; width:100%">
</table>